import translator from '@Components/Utilities/Translator';

const ListingBanner = (props) => {
    return (
        <div className='listing-group-banner'>
            <a href={props.Url} className={props.CssClass} target='_blank' aria-label={props.DisplayText + " (" + translator.translate('sandhills.opensinanewtab') + ")"}>
                {props.ImgSource && <img src={props.ImgSource} alt={props.ImgAlt} className={props.ImgCssClass} width={props.ImgWidth > 0 ? props.ImgWidth : ''} height={props.ImgHeight > 0 ? props.ImgHeight : ''} aria-hidden='true'/>}
                <span>{props.DisplayText}</span>
            </a>
        </div>
    );
};

export default ListingBanner;